import { useState } from 'react';
import {
  IonHeader,
  IonToolbar,
  IonButton,
  IonTitle,
  IonContent,
  IonModal,
  IonList,
  IonItem,
  IonLabel,
  IonCheckbox,
  IonSearchbar
} from '@ionic/react';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import erCategoryStore from 'stores/er-category.store';

import classes from './style.module.scss';

const CategoryFilterModal = ({ isOpen, close, apply, selectedCatIds }) => {
  const [searchText, setSearchText] = useState('');
  const [selectedCategoryIds, setSelectedCategoryIds] =
    useState(selectedCatIds);
  const erCategories = erCategoryStore.getObjects();
  const isLoading = erCategoryStore.getIsLoading();
  let erCategoriesFiltered = toJS(erCategories);
  if (searchText.length > 0) {
    erCategoriesFiltered = toJS(erCategories).filter((category) => {
      if (category.name.toLowerCase().includes(searchText.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    });
  }

  const handleCategoryIdsChange = (event, catId) => {
    const { checked } = event.detail;
    if (checked) {
      setSelectedCategoryIds([...selectedCategoryIds, catId]);
    } else {
      setSelectedCategoryIds(selectedCategoryIds.filter((id) => id !== catId));
    }
  };

  return (
    <IonModal
      isOpen={isOpen}
      swipeToClose={true}
      onDidDismiss={close}
      className={classes.ionModal}
    >
      <IonHeader>
        <IonToolbar>
          <IonTitle>Select Categories</IonTitle>
          <IonButton
            slot='end'
            fill='clear'
            onClick={() => apply(selectedCategoryIds)}
          >
            Apply
          </IonButton>
          <IonButton
            slot='start'
            fill='clear'
            onClick={close}
            color='secondary'
          >
            Close
          </IonButton>
        </IonToolbar>
        <IonToolbar>
          <IonSearchbar
            className={classes.ionSearchbar}
            debounce={500}
            animated={true}
            onIonChange={(e) => setSearchText(e.detail.value)}
          />
        </IonToolbar>
      </IonHeader>
      <IonContent className={classes.ionContent}>
        <IonList lines='none'>
          {erCategoriesFiltered.map((erCategory) => (
            <IonItem key={erCategory.id} detail={false} button>
              <IonCheckbox
                slot='start'
                checked={selectedCategoryIds.includes(erCategory.id)}
                onIonChange={(e) => handleCategoryIdsChange(e, erCategory.id)}
              />
              <IonLabel>{erCategory.name}</IonLabel>
            </IonItem>
          ))}
        </IonList>
      </IonContent>
    </IonModal>
  );
};

export default observer(CategoryFilterModal);
